import { Model, IModelAttributes, attribute, entity } from 'Models/Model';
import * as Models from 'Models/Entities';
import { makeObservable, observable } from 'mobx';

export interface IOrganisationRouteAttributes extends IModelAttributes {
	organisationId: string;
	routeId: string;

	organisation: Models.OrganisationEntity | Models.IOrganisationEntityAttributes;
	route: Models.RouteEntity | Models.IRouteEntityAttributes;
}

@entity('OrganisationRoute')
export default class OrganisationRoute extends Model implements IOrganisationRouteAttributes {
	@observable
	@attribute()
	public organisationId: string;

	@observable
	@attribute()
	public routeId: string;

	@observable
	@attribute({ isReference: true })
	public organisation: Models.OrganisationEntity;

	@observable
	@attribute({ isReference: true })
	public route: Models.RouteEntity;

	constructor(attributes?: Partial<IOrganisationRouteAttributes>) {
		super(attributes);

		makeObservable(this);

		if (attributes) {
			if (attributes.organisationId) {
				this.organisationId = attributes.organisationId;
			}
			if (attributes.routeId) {
				this.routeId = attributes.routeId;
			}

			if (attributes.organisation) {
				if (attributes.organisation instanceof Models.OrganisationEntity) {
					this.organisation = attributes.organisation;
					this.organisationId = attributes.organisation.id;
				} else {
					this.organisation = new Models.OrganisationEntity(attributes.organisation);
					this.organisationId = this.organisation.id;
				}
			} else if (attributes.organisationId !== undefined) {
				this.organisationId = attributes.organisationId;
			}

			if (attributes.route) {
				if (attributes.route instanceof Models.RouteEntity) {
					this.route = attributes.route;
					this.routeId = attributes.route.id;
				} else {
					this.route = new Models.RouteEntity(attributes.route);
					this.routeId = this.route.id;
				}
			} else if (attributes.routeId !== undefined) {
				this.routeId = attributes.routeId;
			}
		}
	}
}
